import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Stats } from "@/components/landing/Stats";
import { Services } from "@/components/landing/Services";
import { Marquee } from "@/components/landing/Marquee";
import { Audiences } from "@/components/landing/Audiences";
import { Process } from "@/components/landing/Process";
import { WhyUs } from "@/components/landing/WhyUs";
import { DueDiligence } from "@/components/landing/DueDiligence";
import { Verify } from "@/components/landing/Verify";
import { Partners } from "@/components/landing/Partners";
import { Industries } from "@/components/landing/Industries";
import { Coverage } from "@/components/landing/Coverage";
import { Safety } from "@/components/landing/Safety";
import { Testimonials } from "@/components/landing/Testimonials";
import { Jobs } from "@/components/landing/Jobs";
import { GetStarted } from "@/components/landing/GetStarted";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#f4f4f5",
            border: "1px solid #e4e4e7",
            color: "#0a0a0a",
            borderRadius: "0",
          },
        }}
      />
      <Nav />
      <Hero />
      <Stats />
      <Services />
      <Marquee />
      <Audiences />
      <Process />
      <WhyUs />
      <DueDiligence />
      <Verify />
      <Partners />
      <Industries />
      <Coverage />
      <Safety />
      <Testimonials />
      <Jobs />
      <GetStarted />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
